import { createContext, useContext, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { getButtonsDef,
        getTitleByType } from "./helpers/helperModalContext";
import { useTranslation } from "react-i18next";

const ModalContext = createContext();
export const useModal = () => useContext(ModalContext);


export const ModalProvider = ({ children }) => {

    const { t } = useTranslation();
    // Стан діалогу
    const [ show, setShow ] = useState(false);
    const [ buttons, setButtons ] = useState(getButtonsDef(t));
    const [ title, setTitle ] = useState(getTitleByType());
    const [ text, setText ] = useState(null);
    const [ refFirstFocus, setRefFirstFocus ] = useState(null);
    const [ size, setSize ] = useState('');
    const [ idFirstFocus, setIdFirstFocus ] = useState(null);
 
    // Закриття діалогу
    const hideDlg = () => {
        setShow(false)
    }

    /**
     * діалогу (передається контекстом)
     * @param {object} params
     * @param {Array of object} params.buttons = []
     * 
     * @param {string}  params.buttons[].title
     * @param {string}  params.buttons[].variant
     * @param {string}  params.buttons[].handleClick
     * @param {boolean} params.buttons[].disabled
     * 
     * @param {string}  params.type                     Тип ділогу('confirm', 'errror', 'info')
     * @param {string}  params.title                    Заголовок (кастумний)
     * @param {string}  params.text                     Текст діалогу
     * @param {bool}    params.sizeLg                   Признак широкого формату діалогу 
     * @param {ref}     params.refFirstFocus            Елемент який фокусується при показі діалогу
     * @param {string}  params.idFirstFocus
     *  */ 
    const showDlg = (params) => {
        if (params === false) return hideDlg();
        setTitle(params?.title||getTitleByType(params?.type));
        setText(params?.text);
        setButtons(params?.buttons||getButtonsDef(t));
        setRefFirstFocus(params?.refFirstFocus);
        setIdFirstFocus(params.idFirstFocus);
        setShow(true);
        setSize((params?.sizeLg)?'lg':'')
    }

    const handleShow = () => {
        if (refFirstFocus) refFirstFocus?.current?.focus();
        if (idFirstFocus)
            if (document.getElementById(idFirstFocus)) document.getElementById(idFirstFocus).focus();
    } 
         
    return ( 
        <ModalContext.Provider value={{showDlg, hideDlg, setDlgButtons: setButtons}}>
            {children}

            <Modal show={show} onHide={hideDlg}
                onShow={handleShow}
                size={size}>
                <Modal.Header closeButton>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{text}</Modal.Body>
                <Modal.Footer className="modal-dlg-footer">
                    <div className="modal-dlg-actions">
                        {buttons.map((button, index) => {
                            const busy = Boolean(button.busy);
                            return (
                                <Button
                                    key={`${index}-${busy ? 'busy' : 'idle'}`}
                                    className={`min100px modal-dlg-btn${busy ? ' is-busy' : ''}`}
                                    variant={button.variant||'secondary'}
                                    disabled={Boolean(button.disabled)}
                                    onClick={button.handleClick||hideDlg}
                                >
                                    {button.title}
                                </Button>
                            )
                        })}
                    </div>
                </Modal.Footer>
            </Modal>
        </ModalContext.Provider>
    );
};
